const initialState = {
  existenciaDiaria: null,
  fechaConsultaStock: null,
  dataCartaDePorteVetada: null,
  detalleCartaDePorteVetada: [],
  detalle: null,
  fileOk: false,
  fileDetallePdfOk: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'EXISTENCIA_DIARIA':
      return {
        ...state,
        existenciaDiaria: action.data
      }
    case 'ACTUALIZAR_FECHA_CONSULTA_STOCK':
      return {
        ...state,
        fechaConsultaStock: action.fecha
      }
    case 'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA':
      return {
        ...state,
        fechaDesde: action.fechaD,
        fechaHasta: action.fechaH
      }
    case 'TOTAL_CARTA_DE_PORTE_VETADA':
      return {
        ...state,
        dataCartaDePorteVetada: action.data
      }
    case 'ACTUALIZAR_DETALLES':
      return {
        ...state,
        detalle: action.detalle
      }
    case 'DETALLE_CARTA_DE_PORTE_VETADA':
      return {
        ...state,
        detalleCartaDePorteVetada: action.detalle
      }
    case 'GENERAR_PDF':
      return {
        ...state,
        fileOk: action.fileOk
      }
    case 'GENERAR_DETALLE_PDF':
      return {
        ...state,
        fileDetallePdfOk: action.fileDetallePdfOk
      }
    default:
      return state
  }
}
